import classNames from 'classnames';
import React, { useState, useRef, useEffect } from 'react';
import Input from '@/components/Input';
import Select, { components } from 'react-select';
import styles from './style.module.scss';
import { TrackLandingController } from '@/track';

const { EVENT_NAME_MAP } = TrackLandingController;

export interface CountryCodeItemPops {
  zh_name: string;
  d_code: string;
  en_name: string;
  ml: string;
}

interface PhoneInputProps {
  value?: [string, string, string?, string?];
  onChange?(value: [string?, string?, string?, string?]): void;
  placeholder?: string;
  inputClassName?: string;
  countryCodeClassName?: string;
  // arrowClassName?: string;
  countryCode?: CountryCodeItemPops[];
  language?: 'zh' | 'en';
  selectClassName?: string;
  disabledSelect?: boolean;
  disabledInput?: boolean;
  // 脱敏
  phoneVisible?: boolean;
  onClick?(): void;
  inputOnBlur?(e?: any): void;
  countryCodeChange?(value: [string?, string?, string?, string?]): void;
  handleReport?: (event: string) => void;
  handlePhoneChange?(): void;
}

const PhoneInput = ({
  value = ['+1', '', 'United States', ''],
  onChange,
  placeholder = '请输入手机号',
  inputClassName,
  countryCodeClassName,
  // arrowClassName,
  countryCode,
  language,
  selectClassName,
  disabledSelect = false,
  disabledInput = false,
  phoneVisible = false,
  onClick,
  inputOnBlur,
  countryCodeChange,
  handleReport,
  handlePhoneChange,
}: PhoneInputProps) => {
  const [showPanel, setShowPanel] = useState(false);
  const [innerValue, setValue] = useState<string>();
  const codeItemRef = useRef<Record<string, HTMLDivElement>>({});
  const contentRef = useRef<HTMLDivElement>();
  // 真实值
  const [phoneValue, setPhoneValue] = useState<string>();
  // 展示的值
  const [phoneValueShow, setPhoneValueShow] = useState<string>();

  const changeValue = (str: string) => {
    let res = str;
    const len = str.length;
    let pre3 = '';
    let last4 = '';
    pre3 = str.slice(0, 3);
    last4 = str.slice(Math.max(len - 4, 3));
    const star = Math.max(0, len - 7);
    res = pre3 + '*'.repeat(star) + last4;
    return res;
  };

  useEffect(() => {
    if (showPanel && innerValue) {
      codeItemRef.current[innerValue]?.scrollIntoView({ block: 'center' });
    }
  }, [showPanel]);

  useEffect(() => {
    const setMaskOpacity = (e: MouseEvent) => {
      if (e.target !== contentRef.current) {
        setShowPanel(false);
      }
    };
    if (showPanel) {
      window.addEventListener('click', setMaskOpacity);
    }

    return () => {
      window.removeEventListener('click', setMaskOpacity);
    };
  }, [showPanel]);

  useEffect(() => {
    setValue(value[0]);
    const valueSting = String(value[1]);
    if (valueSting && valueSting !== 'undefined') {
      const data = changeValue(valueSting);
      setPhoneValue(value[1]);
      setPhoneValueShow(data);
    }
  }, [value]);

  // 脱敏
  const handleChange = (e: any) => {
    // 获取光标位置
    const ind = e.target.selectionStart - 1;
    // 真实值 未加密的
    let inputValue = '';
    if (phoneValue) {
      inputValue = phoneValue;
    }
    // 输入框获取的值
    const showVlue = e.target.value;
    const isAdd = showVlue.length > inputValue.length;
    const num = Math.abs(inputValue.length - showVlue.length);
    if (isAdd) {
      inputValue =
        inputValue.slice(0, ind - num + 1) + showVlue.slice(ind - num + 1, ind + 1) + inputValue.slice(ind - num + 1);
    } else {
      inputValue = inputValue.slice(0, ind + 1) + inputValue.slice(ind + num + 1);
    }
    const data = changeValue(inputValue);
    // 实际值
    setPhoneValue(inputValue);
    // 展示值
    setPhoneValueShow(data);
    onChange?.([value[0], inputValue, value?.[2], value[3]]);
  };

  // 处理粘贴事件
  const handlePaste = (e: any) => {
    const pasteText = e.clipboardData?.getData('text') || '';
    if (!pasteText) return;
    e.preventDefault();
    const target = e.target as HTMLInputElement;
    const selectionStart = target.selectionStart ?? 0;
    const selectionEnd = target.selectionEnd ?? selectionStart;
    const raw = phoneValue || '';
    const digits = pasteText.replace(/\D/g, '');
    const newRaw = raw.slice(0, selectionStart) + digits + raw.slice(selectionEnd);
    const masked = changeValue(newRaw);
    setPhoneValue(newRaw);
    setPhoneValueShow(masked);
    onChange?.([value[0], newRaw, value?.[2], value?.[3]]);
    handlePhoneChange?.();
  };

  const handleOnBlur = (e: any) => {
    if (inputOnBlur) {
      inputOnBlur(e);
    }
  };

  return (
    <div className={classNames(styles.phoneInputWrap, selectClassName)}>
      {/* 点击区域 */}
      <div className={classNames(styles.countryCode, countryCodeClassName)}>
        <Select
          placeholder=""
          classNamePrefix="select"
          value={countryCode?.find(({ d_code }) => d_code === value[0])}
          onChange={(e) => {
            setValue(e?.d_code);
            onChange?.([e?.d_code, value[1], e?.en_name, e?.ml]);
            countryCodeChange?.([e?.d_code, value[1], e?.en_name, e?.ml]);
          }}
          onFocus={() => {
            handleReport?.('G_FirstOrder_FormPhoneArea_Click');
          }}
          formatOptionLabel={(option) => `${option.d_code} ${language === 'en' ? option.en_name : option.zh_name}`}
          className={styles.select}
          isSearchable
          options={countryCode}
          getOptionValue={(option) => `${option.d_code} ${option.zh_name} ${option.en_name}`}
          isDisabled={disabledSelect}
          components={{
            SingleValue: ({ ...props }) => (
              <components.SingleValue {...props}>{props?.data?.d_code}</components.SingleValue>
            ),
          }}
        />
      </div>

      <Input
        type="tel"
        className={classNames(styles.phoneInput, inputClassName)}
        placeholder={placeholder}
        value={phoneVisible ? phoneValueShow : phoneValue}
        onChange={(e) => {
          handleChange(e);
          handlePhoneChange?.();
        }}
        onPaste={handlePaste}
        name="phone"
        disabled={disabledInput}
        onClick={() => {
          handleReport?.(EVENT_NAME_MAP.FIRSTORDER_FORMPHONE_CLICK);
          onClick?.();
        }}
        onBlur={handleOnBlur}
      />
    </div>
  );
};

export default PhoneInput;
